import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Submit20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M16.2501 4V10.25H4.81077L8.03044 7.03033L6.96978 5.96967L1.93945 11L6.96978 16.0303L8.03044 14.9697L4.81078 11.75H17.7501V4H16.2501Z'
      fill='currentColor'
    />
  </Svg>
);

Submit20.displayName = 'Submit20';
export default Submit20;
